import React, { PureComponent } from "react";
import Translator from "components/Translator";
import styles from "./style.module.scss";
import UnderlinedLink from "components/UnderlinedLink";
import cookie, { CookieKeys } from "managers/CookieManager";
import c from "classnames";

class CookieBanner extends PureComponent {
    constructor(props) {
        super(props);
        const acceptedBanner = cookie.get("accept-cookie");

        this.state = {
            showBanner: !acceptedBanner
        };

        this.setCookie = this.setCookie.bind(this);
        this.toggleBanner = this.toggleBanner.bind(this);
    }

    setCookie() {
        cookie.set(CookieKeys.GDPR_COOKIE, true, 365);
        this.toggleBanner();
    }

    toggleBanner() {
        this.setState(prevState => ({
            showBanner: !prevState.showBanner
        }));
    }

    render() {
        const { showBanner } = this.state;

        const CookieBannerClassNames = [
            [styles.CookieBanner],
            { [styles.visible]: showBanner },
            "font-micro"
        ];

        return (
            <Translator>
                {t => (
                    <div className={c(CookieBannerClassNames)}>
                        <div className="row">
                            <div className="col-12 col-xl-8">
                                <span className={styles.message}>
                                    {t("v1_cookie-message")}{" "}
                                    <UnderlinedLink
                                      active={true}
                                      path="/legal#cookies"
                                      label={t("v1_cookie-message-link-text")}
                                      labelKey="v1_cookie-message-link-text"
                                    />
                                </span>
                            </div>

                            <div
                                className={`${styles.actions} col-12 col-xl-4`}
                            >
                                <div
                                    className={styles.fakeUnderlinedLink}
                                    onClick={this.setCookie}
                                >
                                    <span>{t("v1_cookie-accept")}</span>
                                    <div className={styles.line} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Translator>
        );
    }
}

export default CookieBanner;



// WEBPACK FOOTER //
// ./src/components/CookieBanner/index.js